@for (order of data(); track order) {
  <!-- new -->
  @if (!StringUtils.isEmpty(order?.invoice_id)) {
    <div class="bg-[#FFFFFF] mb-[15px] shadow-md relative">
      @if (!StringUtils.isEmpty(order?.order)) {
        <div class="ml-[4px] pt-[6px]">
          <span class="bg-[#D0F0C0] py-[3px] px-[5px] rounded-[2px]">
            <span class="font-[600] text-[13px] text-[#372222]">
              {{ constants().orderNoHeading }} :
            </span>
            <span class="text-[13px] text-[#5B5B5B]">
              {{ order?.order?.order_no }}
            </span>
          </span>
        </div>
      }
      @if (checkSettlements(order?.transactions)) {
        <div class="absolute top-[0px] right-[4px] text-end">
          <button
            class="text-[12px] text-[#333] border px-[8px] py-[4px] hover:bg-[#f0f0f0] transition border-solid border-[#ccc] mt-[4px] rounded-[4px] leading-4"
            (click)="toggleSettlement(order?.invoice_id)"
          >
            Settlement history
            <span
              class="inline-block ml-[4px] transform transition-transform"
              [ngClass]="{ 'rotate-180': isSettlementOpen[order?.invoice_id] }"
              >▼</span
            >
          </button>

          @if (isSettlementOpen[order?.invoice_id]) {
            <div
              class="absolute right-0 z-10 mt-[5px] w-[300px] md:w-[400px] bg-white border border-[#ccc] rounded shadow-md text-center h-[150px] overflow-auto max-h-max"
            >
              <div
                class="grid grid-cols-3 gap-[10px] bg-[#F4F7FB] px-[10px] py-[5px] font-[600] text-[12px] text-[#333]"
              >
                <div>Settlement date</div>
                <div>Settlement amount</div>
                <div>Mode</div>
              </div>

              @for (transaction of order?.transactions; track transaction) {
                @if (
                  transaction?.settlement_date &&
                  transaction?.type.toLowerCase() == 'credit'
                ) {
                  <div
                    class="grid grid-cols-3 gap-[10px] px-[10px] py-[6px] text-[13px] border-b border-[#eee] border-solid border-[1px] border-t-0"
                  >
                    <div>{{ transaction?.settlement_date | date }}</div>
                    <div class="text-[#3BB000]">{{ transaction?.amount }}</div>
                    <div>{{ transaction?.collection_mode }}</div>
                  </div>
                }
              }
            </div>
          }
        </div>
      }
      <div class="flex gap-[10px] xl:flex-row flex-col p-[20px]">
        <div class="grid grid-cols-1 xl:grid-cols-2 gap-[10px] md:grow">
          <div class="flex">
            <div class="flex flex-col gap-[2px] w-[50%]">
              <div class="font-[600] md:text-[14px] text-[12px] text-[#372222]">
                {{ constants()?.invoiceNoHeading }}
              </div>
              <div class="md:text-[13px] text-[12px] text-[#5B5B5B]">
                {{ order?.invoice_id }}
              </div>
            </div>
            <div class="flex flex-col gap-[2px] w-[50%]">
              <div class="font-[600] md:text-[14px] text-[12px] text-[#372222]">
                {{ constants()?.invoiceAmt }}
              </div>
              <div class="text-[13px] text-[#5B5B5B]">
                {{ order?.formattedInvoiceAmt }}
              </div>
            </div>
          </div>
          <div class="flex flex-wrap">
            <div class="flex flex-col gap-[2px] xl:w-[33.33%] w-[50%]">
              <div class="font-[600] md:text-[14px] text-[12px] text-[#372222]">
                {{ constants()?.dueDateHeading }}
              </div>
              <div class="text-[13px] text-[#5B5B5B]">
                {{ order?.formattedDueDate }}
              </div>
            </div>
            <div class="flex flex-col gap-[2px] xl:w-[33.33%] w-[50%]">
              <div class="font-[600] text-[#372222]">
                {{ constants()?.dueAmountHeading }}
              </div>
              <div class="text-[15px] text-[#EA4324] font-[600]">
                {{ order?.formattedDueAmt }}
              </div>
            </div>

            @if (order?.isPaid) {
              <div
                class="flex flex-col gap-[2px] xl:w-[33.33%] w-[100%] lg:pt-[0px] pt-[10px]"
              >
                <div
                  class="font-[600] md:text-[14px] text-[12px] text-[#372222]"
                >
                  {{ constants()?.settledAmt }}
                </div>
                <div
                  class="md:text-[13px] text-[12px] text-[#3bb000] font-[600]"
                >
                  {{ order?.formattedSettledAmt }}
                </div>
              </div>
            }
          </div>
        </div>
        <div class="flex">
          <div
            class="flex flex-col gap-[10px] items-center justify-center md:w-[100px] w-full"
          >
            <div>
              @if (order?.isPaid) {
                <button
                  class="py-[8px] px-[17px] w-full bg-[#FFFFFF] text-[#3BB000] text-[15px] rounded-[5px] border border-solid flex items-center justify-center gap-[5px] cursor-auto font-[600]"
                  style="border-color: #3bb000 !important"
                >
                  <img
                    src="https://static3.industrybuying.com/a-wk/images/webp/payment-successful.webp"
                    class="w-[15px] h-[15px]"
                  />
                  {{ constants()?.paid }}
                </button>
              } @else {
                <button
                  class="py-[10px] px-[17px] w-full bg-[#162F4D] text-[#FFFFFF] text-[14px] border border-solid border-[#162F4D] rounded-[5px] whitespace-nowrap font-[600] hover:bg-[#f94d00] hover:border-[#f94d00]"
                  (click)="payNow(order?.invoice_id)"
                >
                  {{ constants()?.payNow }}
                </button>
              }
            </div>
            <div>
              @if (!StringUtils.isEmpty(order?.invoice_url)) {
                <button
                  (click)="seeInvoice(order?.invoice_url)"
                  class="py-[1px] px-[25px] w-full bg-transparent text-[#000000] text-[11px] rounded-[5px] flex items-center justify-center gap-[5px] cursor-pointer underline hover:text-[#f94d00]"
                >
                  <span class="whitespace-nowrap">{{
                    constants()?.viewInvoice
                  }}</span>
                </button>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- new /-->
}
